import {
	Box,
	Grid,
	TextField,
	Typography,
	IconButton as IconBtn,
	Skeleton,
} from '@mui/material';
import CustomAccordion from '../components/CustomAccordion';
import { CopyIcon } from '../assets/icons/Icons';

function SubCarePlanList({
	data,
	expanded,
	handleExpansion,
	onPlanChange,
	isLoading,
}) {
	function covertArrayToBulletString(array) {
		return array.map(item => `• ${item}`).join('\n');
	}

	function onCopyPlan(data) {
		const value = data.map(item => `• ${item}`).join('\n');

		if (navigator.clipboard) {
			navigator.clipboard.writeText(value);
		} else {
			const tempTextArea = document.createElement('textarea');
			tempTextArea.value = value;
			document.body.appendChild(tempTextArea);
			tempTextArea.select();
			document.execCommand('copy');
			document.body.removeChild(tempTextArea);
		}
	}

	const handleKeyDown = (e, valueString, index, itemIndex) => {
		if (e.key === 'Enter') {
			e.preventDefault();
			onPlanChange(`${valueString}\n• `, index, itemIndex);
		} else if (e.key === 'Backspace') {
			if (valueString.endsWith('\n• ')) {
				e.preventDefault();
				const newString = valueString.slice(0, -3); // Remove last newline + bullet + space
				onPlanChange(newString, index, itemIndex);
			} else if (valueString.endsWith('•')) {
				e.preventDefault();
				const newString = valueString.slice(0, -1); // Remove last bullet
				onPlanChange(newString, index, itemIndex);
			}
		}
	};

	const textInputStyle = {
		'& .MuiOutlinedInput-root': {
			'& fieldset': {
				border: 'none',
			},
			'&:hover fieldset': {
				border: '1px solid #e0dcdc',
			},
			'&.Mui-focused fieldset': {
				border: '1px solid #e0dcdc',
			},
			fontSize: '14px',
		},
	};

	return (
		<Grid bgcolor={'#FFFFFF'} borderRadius={'5px'} padding={'10px'}>
			{data.length > 0 &&
				data.map((value, index) => {
					return (
						<CustomAccordion
							key={index}
							id={index}
							expanded={expanded === index}
							handleExpansion={handleExpansion(index)}
							mainTitle={value.title}>
							<Grid container marginTop={'10px'}>
								{value.bodyContent.map((item, itemIndex) => {
									return (
										<Grid
											key={itemIndex}
											container
											paddingX={'15px'}
											flexDirection={'column'}>
											<Grid
												container
												justifyContent={'space-between'}
												alignItems={'center'}
												paddingX={'15px'}>
												<Typography
													fontSize={'14px'}
													color={'#28696D'}
													fontWeight={'600'}>
													{item.label}
												</Typography>
												<IconBtn
													disableFocusRipple
													onClick={() =>
														onCopyPlan(item.content)
													}
													style={{
														padding: '0px',
													}}>
													<CopyIcon />
												</IconBtn>
											</Grid>
											<Box padding={'15px'}>
												<TextField
													multiline
													fullWidth
													value={covertArrayToBulletString(
														item.content,
													)}
													onChange={e => {
														onPlanChange(
															e.target.value,
															index,
															itemIndex,
														);
													}}
													keyBindingFn={e => {
														handleKeyDown(
															e,
															covertArrayToBulletString(
																item.content,
															),
															index,
															itemIndex,
														);
													}}
													variant="outlined"
													placeholder=""
													sx={textInputStyle}
												/>
											</Box>
										</Grid>
									);
								})}
							</Grid>
						</CustomAccordion>
					);
				})}
			{isLoading && (
				<Skeleton animation="wave" width={'100%'} height={80} />
			)}
		</Grid>
	);
}

export default SubCarePlanList;
